module.exports = __webpack_public_path__ + "assets/images/growth.b8b86a372af25bec606b94882aae99b5.svg";